import {
  Identifiable,
  Milestone,
  project,
  Project,
  Task,
  Zone,
} from "@planzone/dto";

type SearchResult =
  | {
      type: "project";
      args: Identifiable<Project>;
    }
  | {
      type: "task";
      args: Identifiable<Task> & {
        zone: Identifiable<Zone>;
        project: Identifiable<Project>;
      };
    }
  | {
      type: "milestone";
      args: Identifiable<Milestone> & {
        zone: Identifiable<Zone>;
        project: Identifiable<Project>;
      };
    };

const searchResult: SearchResult = {
  type: "project",
  args: { ...project, uuid: "" },
};

export type { SearchResult };

export { searchResult };
